import React from "react";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import "./rating-component.scss";

interface RatingComponentProps {
  label: string;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  ratingValue?: any;
  isRequired?: any;
  fieldName?: string;
  checked?: string;
}

const RatingComponent: React.FC<RatingComponentProps> = ({
  label,
  className = "",
  onClick,
  disabled,
  ratingValue = [],
  isRequired = false,
  fieldName = "",
  checked = "",
}) => {
  return (
    <div className={`rating-component ${className}`}>
    <FormControl>
      <FormLabel id={fieldName}>{label}</FormLabel>
      <RadioGroup
        row
        name={fieldName}
        defaultValue="top"
      > {ratingValue?.map((star: any) => (
        <FormControlLabel
          key={star}
          control={<Radio checked={checked === star}/>}
          label={star}
          labelPlacement="bottom"
        />))}
      </RadioGroup>
    </FormControl>
    </div>
  );
};

export default RatingComponent;
